module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dialogVisible) ? _c('v-dialog', {
    attrs: {
      "min-width": "150",
      "max-width": "450",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.settings.visible),
      callback: function($$v) {
        _vm.$set(_vm.settings, "visible", $$v)
      },
      expression: "settings.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container rounded pa-3"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Copy Contact to Offices")]), _vm._v(" "), _c('ChipSelector', {
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    },
    attrs: {
      "items": _vm.offices
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.select
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6989b809"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/OfficeSelectionDialog.vue
// module id = 2586
// module chunks = 1